import {
  Box,
  DialogContent,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  styled,
  Typography,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { LinkData } from "components/LinkMenu/LinkMenu";

import { ThemeSwitch } from "./ThemeSwitch";

const StyledDrawer = styled(Drawer)(({ theme }) => ({
  zIndex: theme.zIndex.appBar - 1,
  ".MuiDrawer-paper": {
    boxSizing: "border-box",
    top: `54px`,
    height: `calc(100% - 54px)`,
    backgroundColor: theme.vars.palette.background.default,
  },
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
}));

type ListItemLinkProps = {
  link: LinkData;
};

function ListItemLink({ link }: ListItemLinkProps) {
  if (link.href) {
    return (
      <ListItemButton
        key={link.href}
        component={Link}
        to={link.href}
        aria-current={link.current}
      >
        <ListItemText>{link.name}</ListItemText>
      </ListItemButton>
    );
  }

  return (
    <ListItemButton
      key={link.href}
      aria-current={link.current}
      onClick={link.onClick}
    >
      <ListItemText>{link.name}</ListItemText>
    </ListItemButton>
  );
}

type AdminMenuProps = {
  isOpen: boolean;
  onClose: () => void;
  links: LinkData[];
};

export function AdminMenu({ isOpen, onClose, links }: AdminMenuProps) {
  const { t } = useTranslation();

  return (
    <StyledDrawer open={isOpen} onClose={onClose} anchor={"right"}>
      <DialogContent
        sx={{
          maxWidth: "70vw",
          width: "300px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <List>
          {links.map((link) => (
            <ListItemLink key={link.name} link={link} />
          ))}
        </List>
        <Typography>{t("Select mode")}</Typography>
        <Box sx={{ padding: 2 }}>
          <ThemeSwitch />
        </Box>
      </DialogContent>
    </StyledDrawer>
  );
}
